import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import ComponentUtils from '../component/component-utils';

@Directive({
  selector: '[appActiveRoute]',
  standalone: false,
})
export class ActiveRouteDirective implements AfterViewInit {
  @Input({ alias: 'appActiveRoute', required: true }) route!: string;
  constructor(
    private elementRef: ElementRef,
    private router: Router,
  ) {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      ComponentUtils.updateElement(this.elementRef, !!this.route && this.router.url.includes(this.route));
    }, 80);
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        ComponentUtils.updateElement(this.elementRef, !!this.route && event.urlAfterRedirects.includes(this.route));
      }
    });
  }
}
